import {getUtmTestParameters, parseUtmParams} from "./UtmParser";
import queryString from "query-string";
import {assertEqual, assertTrue} from "../../unittests/UnitTestHelper";
import {calculateShortPageUrlNew, getLmByAdInCmp} from "../../components/lg/widgets/common/LgHelper";


export function testLgParamsParser()
{
    let str = getUtmTestParameters() + "&action=START"
    let res = {}
    let queryParams = queryString.parse(str)
    parseUtmParams(queryParams, res)
    parseLgParameters(queryParams, res)
    assertTrue(res.shortPageUrl.includes("concert-short-generators"))
    assertTrue(res.currentPath !== undefined)
    assertEqual("KOILIN_BELLACIAO", res.currentPath.lmKey)
}
export function parseLgParameters(queryParams, res) {
    res.action = queryParams["action"]
    res.shortPageUrl = calculateShortPageUrlNew(res)
    res.currentPath = getLmByAdInCmp(res.adsCode)
    res.lmKey = queryParams["lmKey"]

}
